/* RunRun 2026-07-09: sincroniza el carrito completo al perfil Klaviyo (dmcl_cart_*)
   para que los mails de carrito abandonado muestren TODOS los productos.
   Solo actúa si el visitante ya está identificado por Klaviyo (isIdentified). */
(function () {
  if (window.__rrKlCartSync) return;
  window.__rrKlCartSync = true;

  var t = null;

  function buildItems(cart) {
    var items = [];
    var list = (cart && cart.items) || [];
    for (var i = 0; i < list.length && i < 20; i++) {
      var it = list[i];
      items.push({
        name: it.product_title || it.title || '',
        variant: (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '',
        qty: it.quantity || 1,
        image: it.image ? String(it.image).replace(/^http:/, 'https:') : '',
        url: it.url ? ('https://drmartens.cl' + String(it.url).split('?')[0]) : 'https://drmartens.cl/cart'
      });
    }
    return items;
  }

  function sync() {
    if (!window.klaviyo || typeof window.klaviyo.isIdentified !== 'function') return;
    window.klaviyo.isIdentified().then(function (ok) {
      if (!ok) return;
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          window.klaviyo.identify({
            dmcl_cart_items: buildItems(cart),
            dmcl_cart_count: (cart && cart.item_count) || 0,
            dmcl_cart_total: Math.round(((cart && cart.total_price) || 0) / 100),
            dmcl_cart_updated: new Date().toISOString()
          });
        })
        .catch(function () {});
    }).catch(function () {});
  }

  function queueSync() {
    clearTimeout(t);
    t = setTimeout(sync, 800);
  }

  var RE = /\/cart\/(add|change|update|clear)/;

  var _fetch = window.fetch;
  window.fetch = function () {
    var a = arguments[0];
    var u = (typeof a === 'string') ? a : ((a && a.url) || '');
    var p = _fetch.apply(this, arguments);
    if (RE.test(u)) {
      p.then(function (res) { if (res && res.ok) queueSync(); }).catch(function () {});
    }
    return p;
  };

  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) {
    if (u && RE.test(String(u))) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) queueSync();
      });
    }
    return _open.apply(this, arguments);
  };

  if (document.readyState !== 'loading') {
    setTimeout(sync, 2500);
  } else {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(sync, 2500); });
  }
})();
